/**
 * The label on the share button, padded so every one is the same width.
 *
 * The count is always shown, including zero. A button that reads "[ SHARE ]"
 * on most rows and "[ SHARE (2) ]" on one is two different widths, and a
 * column of them does not line up -- the eye reads the ragged right edge as
 * disorder before it reads any of the numbers.
 *
 * Right-aligned in a field of two, rather than zero-padded: a leading zero
 * reads as a fixed-format identifier ("device 007"), where a right-aligned
 * number reads as a quantity, which is what this is. Two digits because an
 * organization sharing one device with more than 99 others is not a case
 * worth widening every button for.
 */
export const SHARE_COUNT_WIDTH = 2;

export function shareLabel(count: number): string {
  return countLabel("SHARE", count);
}

/**
 * The same fixed-width "WORD (nn)" label, for any column of counted buttons.
 *
 * Never truncated. A three-digit count makes that one button wider, which is
 * honest; clipping it to keep the column tidy would hide the number the button
 * exists to report.
 */
export function countLabel(word: string, count: number): string {
  return `${word} (${String(count).padStart(SHARE_COUNT_WIDTH, " ")})`;
}
